import header from '../modules/header/index';
import kundservice from '../modules/kundservice';
import NewsletterAction from '../modules/newsletterAction';
import addScrollToTop from '../modules/addScrollToTop';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  kundservice();
  addScrollToTop();

  $(".btn-back").not(".no-history").on("click", function () {
    history.back();
  });

  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });

  $('.content-area p').eq(-2).attr('id', "Map");
  if($(location).attr('href').includes('#Map')) {
    $('html, body').animate({
      scrollTop: $("#Map").offset().top - 188
    }, 500);
  }
})